import React from "react";
import {makeStyles} from "@mui/styles";


export type AppBarStepperProps = {
    steps: number
    activeStep?: number
}


const useStyles = makeStyles(theme => ({
    root: {
        padding: 8,
        borderRadius: "999px",
        backgroundColor: "#6E798C12",
    },
    content: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 -2px",
    },
    step: {
        width: 5,
        height: 5,
        borderRadius: "100%",
        backgroundColor: "#009ACF",
        opacity: 0.3,
        margin: "0 2px",
        "&[data-active=\"true\"]": {
            opacity: 1,
            width: 7,
            height: 7,
        }
    }
}))


export const AppBarStepper = (props: AppBarStepperProps) => {
    const {steps, activeStep} = props;
    const classes = useStyles(props);
    return (
        <div className={classes.root}>
            <div className={classes.content}>
                {Array.from({length: steps}).map((_, step) => (
                    <div key={step} className={classes.step} data-active={step < activeStep}/>
                ))}
            </div>
        </div>
    )
}